import { Transition } from "@uirouter/core";
import { AssuranceApartmentToolbarController } from "../assuranceApartment-toolbar.controller";

export class AssuranceApartmentJournalToolbarController extends AssuranceApartmentToolbarController {
    constructor(
        $injector: angular.auto.IInjectorService,
        $transition: Transition,
    ) {
        super($injector, $transition, {
            viewType: "journal",
        });
    }
}
